module.exports = __webpack_public_path__ + "img/20200610_155911.76b0aabc.jpg";